import Vue from 'vue';
import Vuex from 'vuex';
import zh from '@/locales/zh';
import en from '@/locales/en';

const siteTitles = { chinese: zh.siteTitle, english: en.siteTitle };
let that = new Vue();

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: "chinese",
    visibleLogin: false, //控制是否显示登录页面 //true显示 false不显示
    loginStatus: true, //控制当前状态 是 登录 || 注册 ture登录 false注册
    loginSelect: '0', //控制是账号登录(0) || 短信登录(1)
    loginStateKey: 0, // 当前的登录状态,用来刷新某些组件,重新获取数据
    pageParams: { page: 1, size: 10 },
    standardMenu: [], //标准体系菜单
    progress: 0, //路由加载进度
  },
  getters: {
  },
  mutations: {
    setProgress(a, b) { a.progress = b },
    setStandardMenu(a, b) { a.standardMenu = b },
    setLanguage(a, b) {
      a.language = b;
      that.$FN.setLC('language', a.language);
      // 英文版布局兜底 class（机翻后文案变长）
      if (typeof document !== 'undefined') {
        document.documentElement.classList.toggle('niu-lang-en', a.language === 'english');
        document.title = siteTitles[a.language] || zh.siteTitle;
      }
    },
    setLoginStateKey(a, b) { a.loginStateKey = b },
    setVisibleLogin(a, b) { a.visibleLogin = b },
    setLoginStatus(a, b) { a.loginStatus = b },
    setLoginSelect(a, b) { a.loginSelect = b },
    setPageParams({ pageParams = {} }, b) { pageParams = b },
    initPageParams({ pageParams = {}, b = { page: 1, size: 10 } }) { pageParams = b }
  },
  actions: {
  },
  modules: {
  }
})
